var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('div',[_vm._v(_vm._s(_vm.title))]),(_vm.subtitle)?_c('div',[_c('span',[_vm._v(_vm._s(_vm.subtitle))]),(_vm.haveTime)?_c('RemainingTime'):_vm._e()],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }